
<div class="col-width flex-column gap-large padding-standard  border-radius-small border-gray padding-standard" >
    <h4 class="mat-headline-4">{{'ss-auth.session-expired' | translate}}</h4>
    <button (click)="navigateToLogin()" mat-raised-button color="primary" class="full-width">
        {{'ss-auth.login' | translate}}
    </button>
</div>